<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage" id="sec-1">
<section class="foreword" epub:type="foreword" id="title_page" role="doc-foreword" title="Title Page">
<div class="image" id="pz1-1"><img alt="Title Page with Thomas Nelson logo" id="z1-1" src="images/himg-1-1.jpg"/>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?12474233